import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import content from '../../../utils/content';
import styles from './Entries.module.scss';

const Entries = ({ limit, contentType, featured, image, link, caption }) => {

  const [ loading, setLoading ] = useState(false);
  const [ items, setItems ] = useState([]);

  useEffect(() => {

    setLoading(true);

    const fetchData = contentType === 'blog'
      ? content.getBlogPosts()
      : content.getCaseStudies(featured);

    fetchData
      .then(res => {
        setLoading(false);
        setItems(res.items.slice(0, limit));
      })
      .catch(err => {
        setLoading(false);
        setItems([]);
      });

  }, [limit, contentType, featured]);

  return (
    <div className={styles.root}>

      {
        loading && (
          <div className={styles.loading}>
            Loading...
          </div>
        )
      }

      {
        items.length > 0 && (
          <div className={styles.content}>
            {
              items.map(item => (
                <Link
                  key={item.slug}
                  className={styles.item}
                  aria-label={item.title}
                  to={link(item)}>

                  <div className={`
                    ${styles.image}
                    ${{
                      'cover': styles.cover,
                      'contain': styles.contain,
                    }[image.mode]}
                  `}>

                    <LazyLoadImage
                      src={item[image.field]}
                      alt={item[image.altField] || item.title}
                    />
                  </div>

                  <div className={styles.title}>
                    {item.title}
                  </div>

                </Link>
              ))
            }
          </div>
        )
      }

      <div className={styles.action}>
        <Link to={link()}>
          {caption}
        </Link>
      </div>
    </div>
  );
};

export default Entries;
